
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { useIsMobile } from '@/hooks/use-mobile';

const CTASection = () => {
  const isMobile = useIsMobile();

  const handleSearch = (query: string) => {
    console.log('CTA Search query:', query);
    // In a real app, this would redirect to search results
  };

  return (
    <section className="section-padding bg-autocare-blue">
      <div className="page-container">
        <div className="text-center text-white max-w-3xl mx-auto">
          <span className="inline-block px-3 py-1 text-xs font-semibold uppercase tracking-wide bg-white/10 rounded-full backdrop-blur-sm mb-6">
            سيارتك تستحق الأفضل
          </span>
          
          <h2 className="text-2xl md:text-3xl lg:text-5xl font-bold mb-6">
            اعثر على <span className="text-autocare-yellow">تغيير الزيت</span> المثالي لمركبتك
          </h2>
          
          <p className="text-white/80 text-sm md:text-lg mb-8">أوتو كير يساعدك في اكتشاف نوع الزيت المناسب، والعثور على محلات الخدمة القريبة، وجدولة تغيير الزيت ببضع نقرات فقط.</p>
          
          {/* SearchBar removed */}
          
          <div className="flex flex-col sm:flex-row justify-center space-y-4 sm:space-y-0 sm:space-x-4 mb-12">
            <Link to="/oil-finder" className="bg-autocare-yellow hover:bg-autocare-yellow-light text-autocare-blue font-semibold py-2 px-4 sm:py-3 sm:px-6 rounded-md flex items-center justify-center transition-colors text-sm sm:text-base">
              اعثر على زيتك
              <ArrowRight className="ml-2 h-4 w-4 sm:h-5 sm:w-5" />
            </Link>
            <Link to="/shops" className="btn-outline border-white text-white hover:bg-white/10 hover:text-white py-2 px-4 sm:py-3 sm:px-6 text-sm sm:text-base">
              تصفح المحلات
            </Link>
          </div>
          
          <div className={`flex items-center justify-center ${isMobile ? 'space-x-4 sm:space-x-8' : 'space-x-8 sm:space-x-16'}`}>
            <div className="flex flex-col">
              <span className={`${isMobile ? 'text-xl sm:text-3xl' : 'text-3xl'} font-bold`}>20+</span>
              <span className={`${isMobile ? 'text-xs' : 'text-sm'} mt-1 opacity-80`}>محل خدمة</span>
            </div>
            <div className="flex flex-col">
              <span className={`${isMobile ? 'text-xl sm:text-3xl' : 'text-3xl'} font-bold`}>50+</span>
              <span className={`${isMobile ? 'text-xs' : 'text-sm'} mt-1 opacity-80`}>نوع زيت</span>
            </div>
            <div className="flex flex-col">
              <span className={`${isMobile ? 'text-xl sm:text-3xl' : 'text-3xl'} font-bold`}>3K+</span>
              <span className={`${isMobile ? 'text-xs' : 'text-sm'} mt-1 opacity-80`}>سائق راضٍ</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
